var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('Banner',{attrs:{"type":7}}),_c('div',{staticClass:"about_container"},[_c('div',{staticClass:"about_title"},[_c('h3',[_vm._v(_vm._s(_vm.$t("about_us.about_us")))])]),_c('div',{staticClass:"about_p"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.info)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }